<ng-container *ngIf="showDownTimeMessage">
  <mat-sidenav-container *ngIf="!accessDenied && !showOnbording">
    <div id="particle-main-content">
      <!-- TOOLBAR: Above -->
      <ng-container *ngIf="fuseSettings.layout.toolbar === 'above'">
      </ng-container>
      <!-- / TOOLBAR: Above -->
      <!-- NAVBAR: Top -->
      <particle-nav-bar
        layout="horizontal"
        class="top-navbar hide"
        [ngClass]="fuseSettings.colorClasses.navbar"
        *ngIf="fuseSettings.layout.navigation === 'top'">
      </particle-nav-bar>
      <!-- / NAVBAR: Top -->
      <div
        id="wrapper"
        [class]="
          sidebarService.getFoldingStatus('navbar') === true || isMagicLinkOnly || hideLeftSideBar
            ? gridLayoutClass + ' left-sidebar-close'
            : gridLayoutClass
        "
      >
        <!-- <mat-progress-bar
          *ngIf="showLoadingBar"
          class="loading-bar"
          color="accent"
          mode="indeterminate"
        ></mat-progress-bar> -->
        <!-- NAVBAR: Left -->
        <fuse-sidebar
          [name]="'navbar'"
          [folded]="fuseSettings.layout.navigationFolded"
          [lockedOpen]="'gt-md'"
          class="left-navbar orbitax-sidebar"
          [ngClass]="fuseSettings.colorClasses.navbar"
          *ngIf="
            !isMagicLinkOnly &&
            !hideHeaderBar &&
            (fuseSettings.layout.navigation === 'left' ||
              fuseSettings.layout.navigation === 'top')
          "
        >
          <!--<particle-nav-bar layout="vertical"></particle-nav-bar>-->
          <particle-app-nav-bar
            [(currentProject$)]="currentProject$"
            layout="vertical"
          ></particle-app-nav-bar>
        </fuse-sidebar>
        <!-- / NAVBAR: Left -->
        <!-- TOOLBAR: Below -->
        <ng-container
          *ngIf="!hideHeaderBar && fuseSettings.layout.toolbar === 'below'"
        >
          <particle-toolbar
            class="below"
            [ngClass]="fuseSettings.colorClasses.toolbar"
          ></particle-toolbar>
        </ng-container>
        <!-- / TOOLBAR: Below -->
        <div
          [ngClass]="{
            'left-sidebar-close':
              sidebarService.getFoldingStatus('navbar') == true,
            'right-sidebar-close': isRightSidebarFolded == true,
            'left-sidebar-open':
              sidebarService.getFoldingStatus('navbar') == false,
            'right-sidebar-open': isRightSidebarFolded == false,
            'header-close': hideHeaderBar
          }"
          class="content-wrapper"
        >
          <div class="flex flex-row"
               [ngClass]="
              hideHeaderBar
                ? 'body-content-wrapper-100p'
                : 'body-conent-wrapper'
            "
          >
            <particle-outlet class="mat-white-500-bg"></particle-outlet>
            <!-- / NAVBAR: Right -->
          </div>
          <!-- FOOTER: Below -->
          <ng-container *ngIf="fuseSettings.layout.footer === 'below'">
            <!--<fuse-footer class="below" [ngClass]="fuseSettings.colorClasses.footer"></fuse-footer>-->
          </ng-container>
          <!-- / FOOTER: Below -->
        </div>
        @if(!hideRightSideBar){
        <platform-tool-magic-bar id="platform-magic-bar"></platform-tool-magic-bar>
        }
      </div>
    </div>
    <!-- QUICK PANEL -->
    <mat-sidenav fuseMatSidenavHelper="quick-panel" position="start">
      <particle-applications></particle-applications>
    </mat-sidenav>
    <!-- / QUICK PANEL -->
  </mat-sidenav-container>

  <!-- CUSTOM FUNCTION -->
  <ng-container *ngIf="!showOnbording && fuseSettings.layout.showCustomButton">
    <fuse-theme-options [navigation]="navigation"></fuse-theme-options>
  </ng-container>
  <!-- CUSTOM FUNCTION -->
  <app-down-time-message
    *ngIf="!accessDenied && showDownTimeMessage"
    (continueButtonPressed)="continueToDowntime($event)"
  ></app-down-time-message>
  <mat-sidenav-container *ngIf="accessDenied">
    <particle-access-denied></particle-access-denied>
  </mat-sidenav-container>
</ng-container>

<ng-container *ngIf="!showDownTimeMessage">
  <mat-sidenav-container *ngIf="!accessDenied && !showOnbording">
    <div id="particle-main-content">
      <!-- TOOLBAR: Above -->
      <ng-container *ngIf="fuseSettings.layout.toolbar === 'above'">
      </ng-container>
      <!-- / TOOLBAR: Above -->
      <!-- NAVBAR: Top -->
      <particle-nav-bar
        layout="horizontal"
        class="top-navbar hide"
        [ngClass]="fuseSettings.colorClasses.navbar"
        *ngIf="fuseSettings.layout.navigation === 'top'"
      >
      </particle-nav-bar>
      <!-- / NAVBAR: Top -->
      <div
        id="wrapper"
        [class]="
          sidebarService.getFoldingStatus('navbar') === true || isMagicLinkOnly || hideLeftSideBar
            ? gridLayoutClass + ' left-sidebar-close'
            : gridLayoutClass
        "
      >
        <mat-progress-bar
          *ngIf="showLoadingBar"
          class="loading-bar"
          color="accent"
          mode="indeterminate"
        ></mat-progress-bar>
        <!-- NAVBAR: Left -->
        <fuse-sidebar
          [name]="'navbar'"
          [folded]="fuseSettings.layout.navigationFolded"
          [lockedOpen]="'gt-md'"
          class="left-navbar orbitax-sidebar"
          [ngClass]="fuseSettings.colorClasses.navbar"
          *ngIf="
            !isMagicLinkOnly &&
            !hideHeaderBar &&
            (fuseSettings.layout.navigation === 'left' ||
              fuseSettings.layout.navigation === 'top')
          "
        >
          <!--<particle-nav-bar layout="vertical"></particle-nav-bar>-->
          <particle-app-nav-bar
            [(currentProject$)]="currentProject$"
            layout="vertical"
          ></particle-app-nav-bar>
        </fuse-sidebar>
        <!-- / NAVBAR: Left -->
        <!-- TOOLBAR: Below -->
        <ng-container
          *ngIf="!hideHeaderBar && fuseSettings.layout.toolbar === 'below'"
        >
          <particle-toolbar
            class="below"
            [ngClass]="fuseSettings.colorClasses.toolbar"
          ></particle-toolbar>
        </ng-container>
        <!-- / TOOLBAR: Below -->
        <div
          [ngClass]="{
            'left-sidebar-close':
              sidebarService.getFoldingStatus('navbar') == true,
            'right-sidebar-close': isRightSidebarFolded == true,
            'left-sidebar-open':
              sidebarService.getFoldingStatus('navbar') == false,
            'right-sidebar-open': isRightSidebarFolded == false,
            'header-close': hideHeaderBar
          }"
          class="content-wrapper"
        >
          <div class="flex flex-row"
               [ngClass]="
              hideHeaderBar
                ? 'body-content-wrapper-100p'
                : 'body-conent-wrapper'
            "
          >
            <particle-outlet class="mat-white-500-bg"></particle-outlet>
            <!-- / NAVBAR: Right -->
          </div>
          <!-- FOOTER: Below -->
          <ng-container *ngIf="fuseSettings.layout.footer === 'below'">
            <!--<fuse-footer class="below" [ngClass]="fuseSettings.colorClasses.footer"></fuse-footer>-->
          </ng-container>
          <!-- / FOOTER: Below -->
        </div>
        @if(!hideRightSideBar){
        <platform-tool-magic-bar id="platform-magic-bar"></platform-tool-magic-bar>
        }
        <app-platform-floating-xatbot></app-platform-floating-xatbot>
        <app-platform-floating-demo></app-platform-floating-demo>
        <app-voice-call-global-host></app-voice-call-global-host>
      </div>
    </div>
    <!-- QUICK PANEL -->
    <mat-sidenav fuseMatSidenavHelper="quick-panel" position="start">
      <particle-applications></particle-applications>
    </mat-sidenav>
    <!-- / QUICK PANEL -->
  </mat-sidenav-container>
  <!-- CUSTOM FUNCTION -->
  <ng-container *ngIf="!showOnbording && fuseSettings.layout.showCustomButton">
    <fuse-theme-options [navigation]="navigation"></fuse-theme-options>
  </ng-container>
  <!-- CUSTOM FUNCTION -->
  <particle-onboarding
    *ngIf="!accessDenied && showOnbording"
    [dataPreparationCompleted]="dataPreparationCompleted"
    [totalDataPreparationNeeded]="totalDataPreparationNeeded"
    [isMajorRelease]="isMajorRelease"
    (continueButtonPressed)="continueToOrbitaxButtonPressed($event)"
  ></particle-onboarding>
  <mat-sidenav-container *ngIf="accessDenied">
    <particle-access-denied></particle-access-denied>
  </mat-sidenav-container>
</ng-container>
